module.exports = __webpack_public_path__ + "media/images/webex-17fef9c55054f62dfb9b7048fa2db3ee.png";